import React from 'react';
import { useTranslation } from '../../contexts/LanguageContext';

const DukeSkinSelector = ({ 
  dukeSkins, // Array of all duke skins with images
  dukeSkinWhite, 
  setDukeSkinWhite, 
  dukeSkinBlack, 
  setDukeSkinBlack,
  autoBoardTheme,
  setAutoBoardTheme
}) => {
  const { t } = useTranslation();

  // Helper to render a category of duke skins
  const renderDukeCategory = (category, label, icon, selectedSkin, onSelect, testIdPrefix) => {
    const skins = dukeSkins.filter(s => s.category === category);
    if (skins.length === 0) return null;

    return (
      <div className="duke-category">
        <span className="duke-category-label">{icon} {label}</span>
        <div className="duke-skin-row">
          {skins.map(skin => (
            <button
              key={skin.id}
              className={`duke-skin-button ${selectedSkin === skin.id ? 'active' : ''}`}
              onClick={() => onSelect(skin.id)}
              data-testid={`${testIdPrefix}-${skin.id}`}
            >
              <div className="duke-skin-preview">
                <img src={skin.instant_king} alt={`${skin.name} IK`} className="duke-preview-img" />
                <img src={skin.fight_to_be_king} alt={`${skin.name} FTK`} className="duke-preview-img" />
              </div>
              <span className="duke-skin-name">
                {skin.name.replace('⬜ ', '').replace('⬛ ', '').replace('🔶 ', '')}
              </span>
            </button>
          ))}
        </div>
      </div>
    );
  };

  return (
    <section className="settings-section">
      <h3>🛡️ {t('settings.dukeSkins')}</h3>
      <p className="section-description">{t('settings.dukeSkinsDescription', 'Choose Duke skins for each side - board theme auto-matches!')}</p>
      
      {/* Auto Board Theme Toggle */}
      <div className="auto-theme-toggle">
        <label className="toggle-label">
          <input 
            type="checkbox" 
            checked={autoBoardTheme} 
            onChange={(e) => setAutoBoardTheme(e.target.checked)}
            data-testid="auto-board-theme-toggle"
          />
          <span className="toggle-text">🎨 {t('settings.autoMatchBoard')}</span>
        </label>
      </div>
      
      {/* White Side Duke Selection */}
      <div className="duke-side-section">
        <h4>⬜ {t('settings.whiteSideDuke')}</h4>
        {renderDukeCategory('white', t('settings.lightSkins', 'Light Skins'), '⬜', dukeSkinWhite, setDukeSkinWhite, 'duke-skin-white')}
        {renderDukeCategory('black', t('settings.darkSkins', 'Dark Skins'), '⬛', dukeSkinWhite, setDukeSkinWhite, 'duke-skin-white')}
        {renderDukeCategory('neutral', t('settings.neutralSkins', 'Neutral'), '🔶', dukeSkinWhite, setDukeSkinWhite, 'duke-skin-white')}
      </div>
      
      {/* Black Side Duke Selection */}
      <div className="duke-side-section">
        <h4>⬛ {t('settings.blackSideDuke')}</h4>
        {renderDukeCategory('white', t('settings.lightSkins', 'Light Skins'), '⬜', dukeSkinBlack, setDukeSkinBlack, 'duke-skin-black')}
        {renderDukeCategory('black', t('settings.darkSkins', 'Dark Skins'), '⬛', dukeSkinBlack, setDukeSkinBlack, 'duke-skin-black')}
        {renderDukeCategory('neutral', t('settings.neutralSkins', 'Neutral'), '🔶', dukeSkinBlack, setDukeSkinBlack, 'duke-skin-black')}
      </div>
      
      <p className="section-hint">{t('settings.dukeHint', 'Left: Instant King · Right: Fight to be King')}</p>
    </section>
  );
};

export default DukeSkinSelector;
